import React from "react";
import ServerPaginatedTable from "../../utils/pagination.server";
import PageEmptyContent from "../../utils/page.empty-content";
import PdfIcon from "react-icons/lib/md/picture-as-pdf";
import ExcelIcon from "react-icons/lib/md/insert-drive-file";
import ToolTipItem from "../../utils/tooltip";
import EditIcon from "react-icons/lib/md/edit";
import moment from "moment";
import MoreVertIcon from "react-icons/lib/md/more-vert";
import { appHelpers } from "../../../_helpers";
import "../index.css";


class ActionMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, menuStyle: {} };
    this.menuRef = null;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.menuRef && !this.menuRef.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  toggleMenu = () => {
    // toggle then compute positioning so menu stays inside viewport
    this.setState(
      (prev) => ({ open: !prev.open }),
      () => {
        if (this.state.open && this.menuRef) {
          try {
            const tr = this.menuRef.closest && this.menuRef.closest("tr");
            const rect = tr ? tr.getBoundingClientRect() : null;
            const availableBelow = rect ? window.innerHeight - rect.bottom : Infinity;
            const menuEstimate = 160; // approximate menu height
            const menuStyle = availableBelow < menuEstimate ? { bottom: "20px", top: "auto" } : { top: "20px", bottom: "auto" };
            this.setState({ menuStyle });
          } catch (e) {
            this.setState({ menuStyle: {} });
          }
        } else {
          this.setState({ menuStyle: {} });
        }
      },
    );
  };

  handleEdit = () => {
    this.setState({ open: false });
    this.props.onEdit(this.props.record);
  };

  handleApprove = () => {
    this.setState({ open: false });
    this.props.onApprove(this.props.record);
  };

  render() {
    const { open } = this.state;
    const user = appHelpers.getActiveUser() || {};
    const currentUserName = user.userName || user.UserName || user.username || "";

    return (
      <div
        ref={(ref) => (this.menuRef = ref)}
        style={{ position: "relative", display: "inline-block" }}
      >
        <span className="text-primary pointer" onClick={(e) => { e.stopPropagation(); this.toggleMenu(); }}>
          <MoreVertIcon size="15" color="#43a8df" />
        </span>

        {open && (
          <div
            style={{
              position: "absolute",
              right: 0,
              zIndex: 1000,
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
              minWidth: "160px",
              padding: "6px 0",
              ...(this.state.menuStyle || {}),
            }}
          >
            <div
              className="pointer action-menu-item"
              onClick={(e) => { e.stopPropagation(); this.handleEdit(); }}
              style={{
                padding: "9px 18px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "14px",
                color: "#222",
                cursor: "pointer",
              }}
            >
              <EditIcon size="15" /> Edit rate
            </div>
            {this.props.record && this.props.record.Status !== 2 && this.isApproverAllowed() && (function() {
                const rec = this.props.record || {};
                const createdBy = rec.CreatedBy || rec.createdBy || rec.CreatedByUserName || rec.CreatedByName || "";
                // only allow approve when the creator is not the current user (or createdBy is missing)
                return (!createdBy) || String(createdBy) !== String(currentUserName);
              }).call(this) && (
              <div
                className="pointer action-menu-item"
                onClick={(e) => { e.stopPropagation(); this.handleApprove(); }}
                style={{
                  padding: "9px 18px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "14px",
                  color: "#222",
                  cursor: "pointer",
                }}
              >
                ✓ Approve rate
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  isApproverAllowed() {
    try {
      const user = appHelpers.getActiveUser();
      const role = user && (user.AviRole || user.Role || user.role || "");
      if (!role) return false;
      const r = String(role).toLowerCase();
      return r.includes("vgg") || r.includes("super");
    } catch (e) {
      return false;
    }
  }
}
const Aggregate = ({ downloadPdf, downloadExcel }) => (
  <div className="">
    <div className="pull-right" style={{ marginBottom: "20px" }}>
      <strong>Download: </strong>
      <span className="pointer" onClick={downloadPdf}>
        <ToolTipItem
          key={"downloadPdfIcon"}
          title={
            <PdfIcon
              size="18"
              color="#e53335"
              className="icon-picture-as-pdf"
            />
          }
          content="Download PDF"
          id={"downloadPdfIcon"}
        />
      </span>
      &nbsp;
      <span className="pointer" onClick={downloadExcel}>
        <ToolTipItem
          key={"downloadExcelIcon"}
          title={
            <ExcelIcon
              size="18"
              color="#5ead57"
              className="icon-insert-drive-file"
            />
          }
          content="Download Excel"
          id={"downloadExcelIcon"}
        />
      </span>
    </div>
  </div>
);
const DataTable = ({
  data,
  pageIndex,
  downloadPdf,
  downloadExcel,
  converter,
  onEdit,
  onApprove,
  onRowClick,
}) => {
  return data.length === 0 ? (
    <PageEmptyContent message="No record match your search!" />
  ) : (
    <div className="view">
      <Aggregate
        data={data}
        downloadPdf={downloadPdf}
        downloadExcel={downloadExcel}
      />
      <div className="table-responsive">
        <table className="table table-striped table-hover fixed">
          <thead>
            <tr>
              {/* <th style={{width:"56px"}}>
                                    <span>S/N</span>
                                </th> */}
              <th>
                <span>Country Name</span>
              </th>
              <th>
                <span>Currency code</span>
              </th>
              <th>
                <span>Exchange Rate(NGN)</span>
              </th>
              <th>
                <span>Exchange Rate(USD)</span>
              </th>
              <th>
                <span>USD Equivalent of $20</span>
              </th>
              <th>
                <span>Last modified</span>
              </th>
              <th>
                <span>Status</span>
              </th>
              <th>
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((record, i) => (
              <tr key={i} onClick={() => onRowClick && onRowClick(record)}>
                {/* <td >{`${pageIndex + i + 1}`}</td> */}
                <td>{record.Country}</td>
                <td>{record.CurrencyCode}</td>
                <td>{record.NGNExchangeRate}</td>
                <td>{record.USDExchangeRate}</td>
                <td>{record.USD20_ROE}</td>
                <td>{moment(record.UpdatedDate).format("MMM Do YYYY")}</td>
                <td
                  className={
                    record.Status === 2
                      ? "text-success fw-bold"
                      : "text-warning fw-bold"
                  }
                >
                  {record.Status === 2 ? "Active" : "Pending approval"}
                </td>{" "}
                <td column="Action">
                  <ActionMenu
                    record={record}
                    onEdit={onEdit}
                    onApprove={onApprove}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

class PaginatedResult extends React.Component {
  render() {
    const {
      converter,
      pageSize,
      currentPage,
      totalCount,
      navigate,
      records,
      downloadPdf,
      downloadExcel,
      onEdit,
      onApprove,
      onRowClick,
    } = this.props;
    let pageIndex = (currentPage - 1) * pageSize;

    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12 mb-4">
                <ServerPaginatedTable
                  currentPage={currentPage}
                  fetchMore={navigate}
                  target={
                    <DataTable
                      data={records}
                      pageIndex={pageIndex}
                      downloadPdf={downloadPdf}
                      downloadExcel={downloadExcel}
                      converter={converter}
                      onEdit={onEdit}
                      onApprove={onApprove}
                      onRowClick={onRowClick}
                    />
                  }
                  pageSize={pageSize}
                  totalCount={totalCount}
                />
          </div>
        </div>
      </div>
    );
  }
}

export default PaginatedResult;



// WEBPACK FOOTER //
// ./src/views/exchange-rate/AllRates/all-rates-table.js